export interface RequestParam {
  url: string;
  headers?: Record<string, string>;
  params?: Record<
    string,
    string | number | boolean | readonly (string | number | boolean)[]
  >;
}

export const DEFAULT_HEADERS: Record<string, string> = {
  'Content-Type': 'application/json',
};
